import { action, createRequestTypes } from '../base';

export const extraChargesActionTypes = {
  GET_EXTRA_CHARGES: createRequestTypes('GET_EXTRA_CHARGES'),
  CREATE_EXTRA_CHARGES: createRequestTypes('CREATE_EXTRA_CHARGES'),
  UPDATE_EXTRA_CHARGES: createRequestTypes('UPDATE_EXTRA_CHARGES'),
  DELETE_EXTRA_CHARGES: createRequestTypes('DELETE_EXTRA_CHARGES'),
};

/*
 *
 * @param payload
 * @param orgId
 * @param callback
 */
class ExtraChargesActions {
    createCharge = (payload, callback) => action(extraChargesActionTypes.CREATE_EXTRA_CHARGES.REQUEST, {
      payload,
      callback,
    });

    createChargeLoading = (createChargeLoading) => action(extraChargesActionTypes.CREATE_EXTRA_CHARGES.LOADING, {
      createChargeLoading,
    })

     updateCharge = (payload, callback) => action(extraChargesActionTypes.UPDATE_EXTRA_CHARGES.REQUEST, {
       payload,
       callback,
     });

    updateChargeLoading = (updateChargeLoading) => action(extraChargesActionTypes.UPDATE_EXTRA_CHARGES.LOADING, {
      updateChargeLoading,
    })

    /**
     *
     * @param payload
     * @param callback
     */
    getCharges = (orgId,entityName, callback) => action(extraChargesActionTypes.GET_EXTRA_CHARGES.REQUEST, {
      orgId,entityName, callback,
    })

    /**
     *
     * @return
     */
    getChargeLoading = (getChargeLoading) => action(extraChargesActionTypes.GET_EXTRA_CHARGES.LOADING, {
      getChargeLoading,
    })

    /**
     * @return
     */
    getChargesSuccess = (extraChargesResults) => action(extraChargesActionTypes.GET_EXTRA_CHARGES.SUCCESS, {
      extraChargesResults,
    })

    deleteCharge = (payload, callback) => action(extraChargesActionTypes.DELETE_EXTRA_CHARGES.REQUEST, {
      payload,
      callback,
    });

    /**
     *
     * @return
     */
    deleteChargeLoading = (deleteChargeLoading) => action(extraChargesActionTypes.DELETE_EXTRA_CHARGES.LOADING, {
      deleteChargeLoading,
    })
}
export default new ExtraChargesActions();
